import React from 'react';
import { TextBox } from '../../../components/ui/TextBox';
import { Button } from '../../../components/ui/Button';
import { ComboBoxWithSearch, Option } from '../../../components/ui/ComboBoxWithSearch';

export type UpdateViewProps = {
  form: {
    name: string;
    location: string;
    serialNumber: string;
    description?: string;
    status?: 'online' | 'offline';
  };
  setField: <K extends keyof UpdateViewProps['form']>(key: K, value: UpdateViewProps['form'][K]) => void;
  onSubmit: () => void;
  onCancel: () => void;
  loading?: boolean;
  error?: string | null;
};

const statusOptions: Option[] = [
  { label: 'Online', value: 'online' },
  { label: 'Offline', value: 'offline' },
];

export const MachineUpdateView: React.FC<UpdateViewProps> = ({ form, setField, onSubmit, onCancel, loading, error }) => {
  return (
    <div className="mx-auto max-w-2xl">
      <h1 className="mb-3 text-xl font-semibold">Edit Machine</h1>
      <div className="space-y-3">
        <TextBox label="Name" value={form.name} onChange={e => setField('name', e.target.value)} required />
        <TextBox label="Location" value={form.location} onChange={e => setField('location', e.target.value)} required />
        <TextBox label="Serial Number" value={form.serialNumber} onChange={e => setField('serialNumber', e.target.value)} required />
        <TextBox label="Description" value={form.description || ''} onChange={e => setField('description', e.target.value)} />
        <ComboBoxWithSearch label="Status" options={statusOptions} value={form.status} onChange={v => setField('status', v as any)} />
      </div>
      {error && <div className="mt-3 text-sm text-destructive">{error}</div>}
      <div className="mt-4 flex gap-2">
        <Button onClick={onSubmit} disabled={loading}>{loading ? 'Saving...' : 'Save'}</Button>
        <Button variant="outline" onClick={onCancel}>Cancel</Button>
      </div>
    </div>
  );
};

export default MachineUpdateView;
